/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B040040 発注完了入力
 */
import { Column, Query } from "@material-table/core";
import {
  B000170ShireNm,
  B000200JanshohinNmr,
  B000200ShohinNmr,
  B040020Get,
  B040040Find,
  B040040FindRequest,
  B040040Update,
  B040040UpdateRequest,
  catchRestError,
} from "clients/rest";
import {
  msgState,
  SCodeSelect,
  SConfirmDialog,
  SDateField,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  STable,
  SText,
  STextField,
} from "components";
import { getClientMessage } from "messages";
import {
  B040040KanryoKbn,
  B040040KanryoKbnTable,
  B040040SyuturyokuKbn,
  getSCode,
  SCode,
} from "messages/codes";
import { labels } from "messages/labels";
import {
  B000120,
  B000130,
  B000140,
  B000170,
  B000200,
  B000202,
  B040010InputData,
} from "pages";
import { createRef, useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import {
  atom,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from "recoil";
import { dateWithSlashAt, mapIds } from "services";
import { editKbn, eigyoKengen } from "services/codes";
import {
  authState,
  focusState,
  menusState,
  navigateTypeState,
  useFocus,
} from "states";

// 呼び出し時のプロパティ
type Props = Partial<{
  // 呼び出し元へデータを送る場合に設定する。
  handleSubmit: (data: any) => void;
}>;

// 検索条件を格納するデータタイプ
type SearchedFields = {
  searched: boolean;
} & Partial<{
  fields: Fields;
  page: number;
  pageSize: number;
  sort: string[];
}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  hachuYmdFrom: string;
  hachuYmdTo: string;
  nyukayoteiYmdFrom: string;
  nyukayoteiYmdTo: string;
  eigyoCdFrom: string;
  eigyoCdTo: string;
  bumonCdFrom: string;
  bumonCdTo: string;
  shainCdFrom: string;
  shainCdTo: string;
  hachudenpyoNoFrom: string;
  hachudenpyoNoTo: string;
  shireCd: string;
  shireNm: string;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  shohinCd: string;
  shohinNmr: string;
  kanryoKbn: SCode;
  janCd: string;
  janshohinNmr: string;
  shutsuryokujun: SCode;
}>;

// テーブル定義
type Data = Partial<{
  gyoNo: string;
  kanryoKbn: string;
  kanryoKbnView: string;
  uchiwakeNmr: string;
  hachuYmd: string;
  nyukayoteiYmd: string;
  hachudenpyoNo: string;
  hachudenpyoNoF: string;
  hachugyoNo: string;
  shohinCd: string;
  shohinNm: string;
  hachusu: string;
  shiresu: string;
  hachuzansu: string;
  hachuKin: string;
  hachuzanKin: string;
  shireNm: string;
  shainCd: string;
  shainNm: string;
  bumonCd: string;
  bumonNmr: string;
  version: string;
  meiVersion: string;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  hachuYmdFrom: "",
  hachuYmdTo: "",
  nyukayoteiYmdFrom: "",
  nyukayoteiYmdTo: "",
  eigyoCdFrom: "",
  eigyoCdTo: "",
  bumonCdFrom: "",
  bumonCdTo: "",
  shainCdFrom: "",
  shainCdTo: "",
  hachudenpyoNoFrom: "",
  hachudenpyoNoTo: "",
  shireCd: "",
  shireNm: "",
  shodaibun: "",
  shochubun: "",
  shoshobun: "",
  shohinCd: "",
  shohinNmr: "",
  kanryoKbn: getSCode(B040040KanryoKbn, "0"),
  janCd: "",
  janshohinNmr: "",
  shutsuryokujun: getSCode(B040040SyuturyokuKbn, "0"),
};

// テーブルを定義する。
const columns: Column<Data>[] = [
  { field: "gyoNo", title: "行　", width: "4rem", align: "right" },
  {
    field: "kanryoKbnView",
    title: "完了",
    width: "4rem",
    render: (data) => {
      return getSCode(B040040KanryoKbnTable, data.kanryoKbn?.toString() ?? "0")
        ?.label;
    },
  },
  {
    field: "uchiwakeNmr",
    title: "区分",
    width: "6rem",
  },
  {
    field: "hachuYmd",
    title: "発注日",
    width: "6rem",
    render: (data) => {
      if (data.hachuYmd! !== null && data.hachuYmd! !== "") {
        return dateWithSlashAt(data.hachuYmd!);
      }
    },
  },
  {
    field: "nyukayoteiYmd",
    title: "希望納期",
    width: "6rem",
    render: (data) => {
      if (data.nyukayoteiYmd! !== null && data.nyukayoteiYmd! !== "") {
        return dateWithSlashAt(data.nyukayoteiYmd!);
      }
    },
  },
  {
    field: "hachudenpyoNoF",
    title: "発注No.",
    width: "8rem",
  },
  { field: "shohinCd", title: "商品コード", width: "7rem" },
  { field: "shohinNm", title: "商品名", width: "25rem" },
  {
    field: "hachusu",
    title: "発注数　",
    width: "6rem",
    align: "right",
    render: (data) => data.hachusu?.toLocaleString(),
  },
  {
    field: "shiresu",
    title: "入荷数　",
    width: "6rem",
    align: "right",
    render: (data) => data.shiresu?.toLocaleString(),
  },
  {
    field: "hachuzansu",
    title: "発注残数　",
    width: "6rem",
    align: "right",
    render: (data) => data.hachuzansu?.toLocaleString(),
  },
  {
    field: "hachuKin",
    title: "発注金額　",
    width: "6rem",
    align: "right",
    render: (data) => data.hachuKin?.toLocaleString(),
  },
  {
    field: "hachuzanKin",
    title: "発注残金額　",
    width: "6rem",
    align: "right",
    render: (data) => data.hachuzanKin?.toLocaleString(),
  },
  { field: "shireNm", title: "仕入先", width: "13rem" },
  { field: "shainNm", title: "発注担当者", width: "10rem" },
  { field: "bumonNmr", title: "発注担当部門", width: "10rem" },
  { field: "shainCd", title: "発注担当者コード", hidden: true },
  { field: "bumonCd", title: "発注担当部門コード", hidden: true },
  { field: "kanryoKbn", hidden: true },
  { field: "version", hidden: true },
  { field: "meiVersion", hidden: true },
  { field: "hachudenpyoNo", hidden: true },
  { field: "hachugyoNo", hidden: true },
];

const focusId = "B040040";

// B040040 発注完了入力
export const B040040 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

// 検索条件を格納するステート
const B040040State = atom<SearchedFields>({
  key: "B040040State",
  default: {
    searched: false,
    fields: defaultFields,
  },
});

const Page = (props: Props) => {
  // 状態管理の初期設定
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  // テーブルの値取得用Ref
  const tableRef = createRef();
  // 初回検索用のフラグ
  const [searched, setSearched] = useState(false);
  // 検索ボタン押下時に初期ページにするステート
  const isDefaultPage = useRef(false);
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // エラー表示
  const setMsg = useSetRecoilState(msgState);
  // 画面遷移の処理
  const navigate = useNavigate();
  const [menuNavigate, setMenuNavigate] = useRecoilState(navigateTypeState);
  // テーブル行で選択されたデータ
  const [rowData, setRowData] = useState<Partial<Data>>();
  // selectboxで選択された行のデータ
  const [selectedData, setSelectedData] = useState<Data[]>([]);
  // ボタンの活性・非活性
  const [disabledHachuDetail, setDisabledHachuDetail] = useState(true);
  const [disabledHachuExecute, setDisabledHachuExecute] = useState(true);

  // 検索条件の保持
  const [searchedFeields, setSearchedFields] = useRecoilState(B040040State);

  // ログインユーザー情報
  const auth = useRecoilValue(authState);
  // 所属営業所コードでの営業所コード入力制御
  const [isEigyoCdHonsha, setIsEigyoCdHonsha] = useState(true);
  // menusステート取得
  const menus = useRecoilValue(menusState);
  // 営業所権限取得
  const eigyosyoKengen = menus["040"].pages["040040"].eigyosyoKengen;

  // 初期表示イベント
  useEffect(() => {
    if (menuNavigate === "menu") {
      // 自営業所の設定
      // イベント利用権限定義マスタ.営業所権限が"0"(所属営業所のみ指定可)の場合、
      if (eigyosyoKengen === eigyoKengen.only) {
        // 自営業所コード(変更不可)の設定
        methods.setValue("eigyoCdFrom", auth?.eigyoCd!);
        methods.setValue("eigyoCdTo", auth?.eigyoCd!);
        // 入力部非活性化
        setIsEigyoCdHonsha(false);
      }
      // 利用権限定義マスタ.営業所権限が"1"(全営業所指定可権限)の場合、
      else if (eigyosyoKengen === eigyoKengen.all) {
        // 空白(入力可能)
        setIsEigyoCdHonsha(true);
      }
      // 初期表示
      focus(1);
      return;
    }

    if (searchedFeields.searched) {
      // 検索条件が保存されている
      const fields = searchedFeields.fields;
      if (typeof fields !== "undefined") {
        methods.setValue("hachuYmdFrom", fields.hachuYmdFrom);
        methods.setValue("hachuYmdTo", fields.hachuYmdTo);
        methods.setValue("nyukayoteiYmdFrom", fields.nyukayoteiYmdFrom);
        methods.setValue("nyukayoteiYmdTo", fields.nyukayoteiYmdTo);
        methods.setValue("eigyoCdFrom", fields.eigyoCdFrom);
        methods.setValue("eigyoCdTo", fields.eigyoCdTo);
        methods.setValue("bumonCdFrom", fields.bumonCdFrom);
        methods.setValue("bumonCdTo", fields.bumonCdTo);
        methods.setValue("shainCdFrom", fields.shainCdFrom);
        methods.setValue("shainCdTo", fields.shainCdTo);
        methods.setValue("hachudenpyoNoFrom", fields.hachudenpyoNoFrom);
        methods.setValue("hachudenpyoNoTo", fields.hachudenpyoNoTo);
        methods.setValue("shireCd", fields.shireCd);
        methods.setValue("shireNm", fields.shireNm);
        methods.setValue("shodaibun", fields.shodaibun);
        methods.setValue("shochubun", fields.shochubun);
        methods.setValue("shoshobun", fields.shoshobun);
        methods.setValue("shohinCd", fields.shohinCd);
        methods.setValue("shohinNmr", fields.shohinNmr);
        methods.setValue("kanryoKbn", fields.kanryoKbn);
        methods.setValue("janCd", fields.janCd);
        methods.setValue("janshohinNmr", fields.janshohinNmr);
        methods.setValue("shutsuryokujun", fields.shutsuryokujun);
        setSearched(true);
        return;
      }
    }
  }, []);

  // テーブル行チェックボックス選択時
  const handleCheckTableRow = (data: Data[]) => {
    // 行が選択されている場合のみ実行する。
    const disabled = data.length <= 0;
    setDisabledHachuExecute(disabled);
    setSelectedData(data);
  };

  // 実行ボタンクリックイベント
  const handleClickExecuteButton = () => {
    // リクエスト作成
    const param: B040040UpdateRequest = {
      hachumeiList: selectedData.map((value) => {
        return {
          kanryoKbn: value.kanryoKbn,
          hachudenpyoNo: value.hachudenpyoNo,
          hachugyoNo: value.hachugyoNo,
          version: value.version,
          meiVersion: value.meiVersion,
        };
      }),
    };
    // API呼び出し
    B040040Update(param)
      .then(() => {
        (tableRef.current as any).onQueryChange();
        // ボタン非活性化
        setDisabledHachuDetail(true);
        setDisabledHachuExecute(true);
        // 選択されているデータを空にする
        setRowData({});
        setSelectedData([]);
        setMsg(getClientMessage("B040040_001"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // テーブル行選択時
  const handleSelectTableRow = (_: any, rowData: Data | undefined) => {
    // 行が選択されていないときはボタン非活性
    const disabled = typeof rowData === "undefined";
    setDisabledHachuDetail(disabled);

    // データを保存
    setRowData(rowData);
  };

  // テーブル行ダブルクリック時・詳細ボタンクリック時
  const handleDoubleClickTableRow = (data: Data) => {
    // 受注データの検索を行う
    B040020Get({ hachudenpyoNo: data.hachudenpyoNo })
      .then((value) => {
        // 確定済・キャンセル済のデータ→参照モード それ以外→編集モード
        const inputData: B040010InputData = {
          editKbn: editKbn.reference,
          hachu: value.data,
        };
        setSearchedFields({ searched: true, fields: methods.getValues() });
        // 発注入力画面へ遷移する。
        setMenuNavigate("next");
        navigate("/b040010", { state: inputData });
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 詳細ボタンクリック時
  const handleClickShowDetailButton = () => {
    // 行が選択されている場合のみ実行する。
    if (typeof rowData === "undefined") {
      return;
    }

    // 発注データの検索を行う
    B040020Get({ hachudenpyoNo: rowData.hachudenpyoNo })
      .then((value) => {
        const inputData: B040010InputData = {
          editKbn: editKbn.reference,
          hachu: value.data,
        };
        setSearchedFields({ searched: true, fields: methods.getValues() });
        // 発注入力画面へ遷移する。
        setMenuNavigate("next");
        navigate("/b040010", { state: inputData });
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 検索時の初期化処理
  const handleResetSearch = () => {
    // ボタン非活性化
    setDisabledHachuDetail(true);
    setDisabledHachuExecute(true);
    // 選択されているデータを空にする
    setRowData({});
    (tableRef.current as any).handleClearSelect();
  };

  // 検索ボタンクリックイベント
  const handleClickSearchButton = () => {
    // 初期化
    handleResetSearch();
    // 検索可能に変更
    setSearched(true);
    // 初期ページ設定
    isDefaultPage.current = true;
    // テーブル再検索
    (tableRef.current as any).onQueryChange();
  };

  // 検索イベント
  const handleSearch = (query: Query<Data>) => {
    return new Promise<any>((resolve) => {
      // 初回検索をしない
      if (!searched) {
        resolve({
          data: [],
          page: 0,
          totalCount: 0,
        });
        return;
      }

      // 検索フォームのデータを取得する。
      const fields = methods.getValues();

      // 出力順の値に応じたソート処理
      let order;
      if (fields.shutsuryokujun?.value === "0") {
        order = ["hachuYmd,asc"];
      } else if (fields.shutsuryokujun?.value === "1") {
        order = ["nyukayoteiYmd,asc"];
      } else if (fields.shutsuryokujun?.value === "2") {
        order = ["shireCd,asc"];
      } else if (fields.shutsuryokujun?.value === "3") {
        order = ["shohinCd,asc"];
      }

      // 初期ページ表示の場合、0を設定する。
      query.page = isDefaultPage.current ? 0 : query.page;

      // 検索パラメータを作成する。
      const param: B040040FindRequest = {
        hachuYmdFrom: fields.hachuYmdFrom,
        hachuYmdTo: fields.hachuYmdTo,
        nyukayoteiYmdFrom: fields.nyukayoteiYmdFrom,
        nyukayoteiYmdTo: fields.nyukayoteiYmdTo,
        eigyoCdFrom: fields.eigyoCdFrom,
        eigyoCdTo: fields.eigyoCdTo,
        bumonCdFrom: fields.bumonCdFrom,
        bumonCdTo: fields.bumonCdTo,
        shainCdFrom: fields.shainCdFrom,
        shainCdTo: fields.shainCdTo,
        hachudenpyoNoFrom: fields.hachudenpyoNoFrom,
        hachudenpyoNoTo: fields.hachudenpyoNoTo,
        shireCd: fields.shireCd,
        shodaibun: fields.shodaibun,
        shochubun: fields.shochubun,
        shoshobun: fields.shoshobun,
        shohinCd: fields.shohinCd,
        kanryoKbn: fields.kanryoKbn?.value!,
        janCd: fields.janCd,
        // ページネーションの設定
        page: query.page,
        size: query.pageSize,
        // ソートの設定
        sort: order,
      };
      // API呼び出し
      B040040Find(param)
        // 正常取得時
        .then((value) => {
          const offset = query.pageSize * query.page;
          const data = mapIds(value.data.content, "gyoNo", offset);
          const filtered = data.filter(
            (v: Data) => Number(v.shiresu) < Number(v.hachusu)
          );
          // setDisabledHachuExecute(filtered.length <= 0);
          filtered.map((v) => (v["tableData"] = { checked: true }));
          handleCheckTableRow(filtered);
          resolve({
            data: data,
            page: value.data.number,
            totalCount: value.data.totalElements,
          });
        })
        // エラー時
        .catch((reason) => {
          catchRestError(reason, navigate, setMsg);
          resolve({
            data: [],
            page: 0,
            totalCount: 0,
          });
        })
        .finally(() => {
          // 初期ページ表示をオフにする。
          isDefaultPage.current = false;
        });
    });
  };

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="発注完了入力"
        gridTemplateColumns="6rem 4rem 4rem 1rem 4rem 4rem 3rem 3rem 6rem 9rem 1rem 9rem 3rem"
      >
        <SLabel>発注日</SLabel>
        <SDateField name="hachuYmdFrom" gridColumn="span 2" {...register(1)} />
        <SText>～</SText>
        <SDateField name="hachuYmdTo" gridColumn="span 2" {...register(2)} />
        <SLabel gridColumn="9">希望納期</SLabel>
        <SDateField name="nyukayoteiYmdFrom" {...register(3)} />
        <SText>～</SText>
        <SDateField name="nyukayoteiYmdTo" {...register(4)} />

        <SLabel gridColumn="1">営業所</SLabel>
        {isEigyoCdHonsha ? (
          <SNumberField
            name="eigyoCdFrom"
            code
            size={6}
            gridColumn="span 2"
            dialog={<B000120 />}
            handleSubmit={(data: any) => {
              methods.setValue("eigyoCdFrom", data.eigyoCd);
            }}
            {...register(5)}
          />
        ) : (
          <STextField name="eigyoCdFrom" disabled gridColumn="span 2" />
        )}
        <SText>～</SText>
        {isEigyoCdHonsha ? (
          <SNumberField
            name="eigyoCdTo"
            code
            size={6}
            gridColumn="span 2"
            dialog={<B000120 />}
            handleSubmit={(data: any) => {
              methods.setValue("eigyoCdTo", data.eigyoCd);
            }}
            {...register(6)}
          />
        ) : (
          <STextField name="eigyoCdTo" disabled gridColumn="span 2" />
        )}

        <SLabel gridColumn="1">発注担当部門</SLabel>
        <SNumberField
          name="bumonCdFrom"
          code
          size={6}
          gridColumn="span 2"
          dialog={<B000130 />}
          handleSubmit={(data: any) => {
            methods.setValue("bumonCdFrom", data.bumonCd);
          }}
          {...register(7)}
        />
        <SText>～</SText>
        <SNumberField
          name="bumonCdTo"
          code
          size={6}
          gridColumn="span 2"
          dialog={<B000130 />}
          handleSubmit={(data: any) => {
            methods.setValue("bumonCdTo", data.bumonCd);
          }}
          {...register(8)}
        />
        <SLabel gridColumn="9">発注担当者</SLabel>
        <SNumberField
          name="shainCdFrom"
          code
          size={7}
          dialog={<B000140 />}
          handleSubmit={(data: any) => {
            methods.setValue("shainCdFrom", data.shainCd);
          }}
          {...register(9)}
        />
        <SText>～</SText>
        <SNumberField
          name="shainCdTo"
          code
          size={7}
          dialog={<B000140 />}
          handleSubmit={(data: any) => {
            methods.setValue("shainCdTo", data.shainCd);
          }}
          {...register(10)}
        />

        <SLabel gridColumn="1">発注No.</SLabel>
        <SNumberField
          name="hachudenpyoNoFrom"
          code
          size={10}
          {...register(11)}
          gridColumn="span 2"
        />
        <SText>～</SText>
        <SNumberField
          name="hachudenpyoNoTo"
          code
          size={10}
          gridColumn="span 2"
          {...register(12)}
        />

        <SLabel gridColumn="1">仕入先</SLabel>
        <SNumberField
          name="shireCd"
          code
          size={6}
          gridColumn="span 2"
          onBlur={() => B000170ShireNm(methods, navigate, setMsg)}
          dialog={<B000170 />}
          handleSubmit={(data: any) => {
            methods.setValue("shireCd", data.shireCd);
            methods.setValue("shireNm", data.shireNmr);
          }}
          {...register(13)}
        />
        <STextField name="shireNm" size={24} disabled gridColumn="span 4" />

        <SLabel gridColumn="1">商品分類</SLabel>
        <SNumberField
          label="商品分類(大)"
          name="shodaibun"
          code
          size={3}
          {...register(14)}
        />
        <SNumberField
          label="商品分類(中)"
          name="shochubun"
          code
          size={3}
          {...register(15)}
        />
        <SNumberField
          label="商品分類(小)"
          name="shoshobun"
          code
          size={3}
          gridColumn="span 2"
          dialog={<B000202 />}
          handleSubmit={(data: any) => {
            if (data.shochubun === null) {
              methods.setValue("shodaibun", data.shodaibun);
              methods.setValue("shochubun", "");
              methods.setValue("shoshobun", "");
            } else if (data.shoshobun === null) {
              methods.setValue("shodaibun", data.shodaibun);
              methods.setValue("shochubun", data.shochubun);
              methods.setValue("shoshobun", "");
            } else {
              methods.setValue("shodaibun", data.shodaibun);
              methods.setValue("shochubun", data.shochubun);
              methods.setValue("shoshobun", data.shoshobun);
            }
          }}
          {...register(16)}
        />
        <SLabel gridColumn="9">商品</SLabel>
        <SNumberField
          label="商品コード"
          name="shohinCd"
          code
          size={10}
          onBlur={() => B000200ShohinNmr(methods, navigate, setMsg)}
          dialog={<B000200 />}
          handleSubmit={(data: any) => {
            methods.setValue("shohinCd", data.shohinCd);
            methods.setValue("shohinNmr", data.shohinNmr);
          }}
          {...register(17)}
        />
        <STextField name="shohinNmr" size={24} disabled gridColumn="span 3" />

        <SLabel gridColumn={1}>完了</SLabel>
        <SCodeSelect
          name="kanryoKbn"
          options={B040040KanryoKbn}
          {...register(18)}
          gridColumn="span 2"
        />

        <SLabel gridColumn="9">JANコード</SLabel>
        <SNumberField
          label="JANコード"
          name="janCd"
          code
          size={13}
          onBlur={() => B000200JanshohinNmr(methods, navigate, setMsg)}
          dialog={<B000200 />}
          handleSubmit={(data: any) => {
            methods.setValue("janCd", data.janCd);
            methods.setValue("janshohinNmr", data.shohinNm);
          }}
          gridColumn="span 2"
          {...register(19)}
        />
        <STextField
          name="janshohinNmr"
          size={24}
          disabled
          gridColumn="span 2"
        />
        <SLabel gridColumn="1">出力順</SLabel>
        <SCodeSelect
          label="出力順"
          name="shutsuryokujun"
          options={B040040SyuturyokuKbn}
          gridColumn="span 2"
          {...register(20)}
        />
        <SNormalButton
          label={labels.buttons.search}
          gridRow="9"
          gridColumn="13"
          align="right"
          onClick={handleClickSearchButton}
          {...register(22)}
        />
      </SFrame>
      <SFrame>
        <STable
          keyName="gyoNo"
          data={handleSearch}
          columns={columns}
          tableRef={tableRef}
          width={1250}
          height={350}
          fixed={6}
          multi
          onRowClick={handleSelectTableRow}
          handleDoubleClick={handleDoubleClickTableRow}
          onSelectionChange={handleCheckTableRow}
          onPageChange={handleResetSearch}
        />
      </SFrame>
      <SFrame gridTemplateColumns="68.7rem 4rem 0.5rem 5rem">
        <SNormalButton
          label={labels.buttons.detail}
          disabled={disabledHachuDetail}
          onClick={handleClickShowDetailButton}
          align="right"
          gridColumn={2}
          {...register(23)}
        />
        <SNormalButton
          label={labels.buttons.execute}
          gridColumn={4}
          {...register(24)}
          disabled={disabledHachuExecute}
          dialog={
            <SConfirmDialog
              title="発注完了"
              msg="選択中の発注明細データを更新します。よろしいですか？"
            />
          }
          dialogAction="confirm"
          handleSubmit={handleClickExecuteButton}
        />
      </SFrame>
    </FormProvider>
  );
};
